import { Text, View, TouchableOpacity, StyleSheet, Dimensions } from 'react-native'

// styles
import { colorPalette, globalStyles } from '../../../static/styles/global'

// components
import HomeMessages from '../../home/HomeMessages'
import { Badge, BadgeProps } from '../button/Badge'
import CardStatus from './CardStatus'

// helpers
import { homeMessageResponseTitle } from '../../../helpers/homeHelper'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface cardInfoProps {
  title: string
  status?:
  | 'NOT STARTED'
  | 'INCOMPLETE'
  | 'PENDING'
  | 'RESUBMIT'
  | 'COMPLETED'
  | 'VERIFY'
  badge?: BadgeProps
  message?: string
  reply?: string
  isAlertMessage?: boolean
  flat?: boolean
  extraParams?: {
    sentMessageDate: string | null
    replyMessageDate: string | null
  }
  initiatorType?: 'E' | 'A'
}

const CardInfoStatus = ({
  title,
  status,
  badge,
  message,
  reply,
  isAlertMessage,
  flat = false,
  extraParams = null,
  initiatorType
}: cardInfoProps): JSX.Element => {

  const [titleHeight, setTitleHeight] = useState(0);
  const { t } = useTranslation()
  return (
    <View>
      <View
        style={[
          globalStyles.hDirection,
          globalStyles.hBetweenItems,
          globalStyles.vCenterItems
        ]}
      >
        {title != t('communicateTitle') &&
          <View style={{ backgroundColor: '#0B495C', padding: 10, position: 'absolute', marginLeft: -20, borderTopLeftRadius: 8, borderBottomLeftRadius: 8, height: titleHeight + 39, justifyContent: 'center', alignItems: 'center' }}>
            <Text style={{ color: '#fff', fontSize: 12 }}>{t('Step')}</Text>
            <Text style={{ color: '#fff', textAlign: 'center', fontSize: 17, fontWeight: 'bold' }}>
              {title == t('storeinformation') ? '1' : (title == t('personalInfoTitle') ? '2' : (title == t('onBoardingTitle') ? '3' : (title == t('scheduleTitle') ? '4' : '')))}
            </Text>
          </View>
        }
        <Text
          style={[
            globalStyles.text,
            globalStyles.fwBold,
            globalStyles.fs18,
            globalStyles.blackTextColor,
            globalStyles.flexOne,
            globalStyles.pr2,
            globalStyles.ml8
          ]}
          onLayout={(event) => {
            const { height } = event.nativeEvent.layout;
            setTitleHeight(height);
          }}

        >
          {title}
        </Text>
        {status ? (
          <CardStatus status={status} flat={flat} />
        ) : (
          badge && (
            <Badge
              text={badge.text}
              textColor={badge.textColor}
              bgColor={badge.bgColor}
            />
          )
        )}
      </View>
      <View>
        {message && isAlertMessage ? (
          <HomeMessages
            message={message}
            reply={reply}
            sentMessageLabel={homeMessageResponseTitle(initiatorType).message}
            sentMessageDate={extraParams?.sentMessageDate}
            replyMessageLabel={homeMessageResponseTitle(initiatorType).response}
            replyMessageDate={extraParams?.replyMessageDate}
            initiatorType={initiatorType}
          />
        ) : message ? (
          <View style={[globalStyles.mt3]}>
            <Text style={[globalStyles.text, globalStyles.grayTextColor]}>
              {message}
            </Text>
          </View>
        ) : (
          <></>
        )}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  messageBox: {
    backgroundColor: colorPalette.lightSecondary,
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 16
  },
  replyBox: {
    backgroundColor: colorPalette.light,
    marginRight: 0
  },
  msgRequest: {
    marginRight: 60
  },
  msgResponse: {
    marginLeft: 60
  },
  rightIndent: {
    marginRight: 60
  },
  leftIndent: {
    marginLeft: 60
  },
  labelGap: { paddingHorizontal: 2 }
})

export default CardInfoStatus